import React from "react";
import { Form, Field } from 'react-final-form'
import PropTypes from "prop-types";
import InputField from "../fields/InputField";
import {composeValidators, required, email, limit} from "../../helpers/ValidateHelper";
import Error from "../fields/Error";

function ForgotPasswordForm({initialValues, onSubmit, onSignIn}) {
    return <Form initialValues={initialValues} onSubmit={onSubmit}>
        {({handleSubmit, submitting}) => (
            <form id="reset-password-active-form" onSubmit={handleSubmit} className="form-validation">
                <div className="form-group">
                    <div className="form-label">Email <span className="rq">*</span></div>
                    <Field
                        name="email"
                        component={InputField}
                        placeholder="e.g. Email@address.com"
                        className="control-input"
                        autoComplete="email"
                        inputProps={{
                            inputMode: 'email',
                            autoCorrect: 'off',
                            spellCheck: 'false',
                            autoCapitalize: 'none',
                        }}
                        validate={composeValidators(
                            required('Please provide an email'),
                            email('Please provide a valid email'),
                            limit('Maximum {limit} characters allowed. You\'ve used {count}.', 320)
                        )}
                    />
                    <Error name="email" />
                </div>
                <div className="form-btn_v3">
                    <button className="btn_v3 btn_v3-md btn_v3-primary" disabled={submitting}>
                        {submitting ? (
                            'Sending...'
                        ) : (
                            'Send Request'
                        )}
                    </button>
                </div>
                {onSignIn && (
                    <p className="control-descr">
                        Remember your password?
                        <span> </span>
                        <a onClick={onSignIn} className="popup-sign-in">Sign In</a>
                    </p>
                )}
            </form>
        )}
    </Form>
}

ForgotPasswordForm.propTypes = {
    initialValues: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
}

export default ForgotPasswordForm;
